import "../../styles/ViewAllButton.scss";

interface ViewAllButtonProps {
  onClick: () => void;
  label?: string;
  highlight?: "flash" | "best" | "normal";
}

const ViewAllButton = ({
  onClick,
  label = "Xem tất cả",
  highlight = "normal",
}: ViewAllButtonProps) => {
  return (
    <div className={`view-all-wrapper ${highlight}`}>
      <button className="view-all-btn" onClick={onClick}>
        {label}
        <span className="arrow">→</span>
      </button>
    </div>
  );
};

export default ViewAllButton;
